import HRISGustoIcon from 'assets/images/HRIS-connect-gusto.svg';
import HRISAdpIcon from 'assets/images/HRIS-connect-ADP.svg';
import HRISBambooIcon from 'assets/images/HRIS-connect-bamboo.svg';
import HRISNamelyIcon from 'assets/images/HRIS-connect-namely.svg';
import HRISZenefitsIcon from 'assets/images/HRIS-connect-zenefits.svg';
import HRISPaychexIcon from 'assets/images/HRIS-connect-paychex.png';
import HRISSuccessfactorsIcon from 'assets/images/HRIS-connect-successfactors.jpeg';
import HRISPaylocityIcon from 'assets/images/HRIS-connect-paylocity.png';
import HRISUkgIcon from 'assets/images/HRIS-connect-ukg.png';
import HRISHumaansIcon from 'assets/images/HRIS-connect-humaans.jpeg';
import HRISTrinetIcon from 'assets/images/HRIS-connect-trinet.png';
import HRISWorkdayIcon from 'assets/images/HRIS-connect-workday.jpeg';
import HRISHRPartnerIcon from 'assets/images/HRIS-connect-HR-partner.jpeg';
import HRISHibobIcon from 'assets/images/HRIS-connect-hibob.jpeg';
import HRISJustworksIcon from 'assets/images/HRIS-connect-justworks.jpeg';
import HRISPersonioIcon from 'assets/images/HRIS-connect-personio.jpeg';
import HRISSageIcon from 'assets/images/HRIS-connect-sage.jpeg';
import HRISSaplingIcon from 'assets/images/HRIS-connect-sapling.png';
import HRISHRCloudIcon from 'assets/images/HRIS-connect-HR-cloud.jpeg';
import HRISChartHopIcon from 'assets/images/HRIS-connect-chart-hop.png';
import HRISnmbrsIcon from 'assets/images/HRIS-connect-nmbrs.png';
import HRISAlexisHRIcon from 'assets/images/HRIS-connect-alexis-HR.png';
import HRISFactorialIcon from 'assets/images/HRIS-connect-factorial.png';
import HRISOfficientIcon from 'assets/images/HRIS-connect-officient.png';
import HRISAlteraIcon from 'assets/images/HRIS-connect-altera.png';
import HRISFreshteamIcon from 'assets/images/HRIS-connect-freshteam.png';
import HRISPeopleHRIcon from 'assets/images/HRIS-connect-people-HR.png';
import HRISbreatheIcon from 'assets/images/HRIS-connect-breathe.jpeg';
import HRISIntelliHRIcon from 'assets/images/HRIS-connect-intelli-HR.jpeg';
import HRISProliantIcon from 'assets/images/HRIS-connect-proliant.jpeg';
import HRISCeridianIcon from 'assets/images/HRIS-connect-ceridian.jpeg';
import HRISLuccaIcon from 'assets/images/HRIS-connect-lucca.jpeg';
import HRISSquareIcon from 'assets/images/HRIS-connect-square.jpeg';
import HRISCharlieIcon from 'assets/images/HRIS-connect-charlie.png';

export const HRIS_GUSTO_PROVIDER = { integration: 'gusto', name: 'Gusto', icon: HRISGustoIcon };

export const MERGE_HRIS_PROVIDERS = [
  { integration: 'adp-workforce-now', name: 'ADP Workforce Now', icon: HRISAdpIcon },
  { integration: 'paylocity', name: 'Paylocity', icon: HRISPaylocityIcon },
  { integration: 'paychex', name: 'Paychex', icon: HRISPaychexIcon },
  { integration: 'ukg-pro', name: 'UKG Pro', icon: HRISUkgIcon },
  { integration: 'trinet', name: 'TriNet', icon: HRISTrinetIcon },
  { integration: 'sap-successfactors', name: 'SAP SuccessFactors', icon: HRISSuccessfactorsIcon },
  { integration: 'ukg-ready', name: 'UKG Ready', icon: HRISUkgIcon },
  { integration: 'workday', name: 'Workday', icon: HRISWorkdayIcon },
  { integration: 'factorial', name: 'Factorial', icon: HRISFactorialIcon },
  { integration: 'bamboohr', name: 'BambooHR', icon: HRISBambooIcon },
  { integration: 'sage-hr', name: 'Sage HR', icon: HRISSageIcon },
  { integration: 'justworks', name: 'Justworks', icon: HRISJustworksIcon },
  { integration: 'hibob', name: 'Hibob', icon: HRISHibobIcon },
  { integration: 'freshteam', name: 'Freshteam', icon: HRISFreshteamIcon },
  { integration: 'zenefits', name: 'Zenefits', icon: HRISZenefitsIcon },
  { integration: 'hr-partner', name: 'HR Partner', icon: HRISHRPartnerIcon },
  { integration: 'personio', name: 'Personio', icon: HRISPersonioIcon },
  { integration: 'sapling', name: 'Sapling', icon: HRISSaplingIcon },
  { integration: 'humaans', name: 'Humaans', icon: HRISHumaansIcon },
  { integration: 'hr-cloud', name: 'HR Cloud', icon: HRISHRCloudIcon },
  { integration: 'square-payroll', name: 'Square Payroll', icon: HRISSquareIcon },
  { integration: 'charthop', name: 'ChartHop', icon: HRISChartHopIcon },
  { integration: 'nmbrs', name: 'Nmbrs', icon: HRISnmbrsIcon },
  { integration: 'namely', name: 'Namely', icon: HRISNamelyIcon },
  { integration: 'alexishr', name: 'AlexisHR', icon: HRISAlexisHRIcon },
  { integration: 'breathe', name: 'Breathe', icon: HRISbreatheIcon },
  { integration: 'proliant', name: 'Proliant', icon: HRISProliantIcon },
  { integration: 'intellihr', name: 'IntelliHR', icon: HRISIntelliHRIcon },
  { integration: 'peoplehr', name: 'PeopleHR', icon: HRISPeopleHRIcon },
  { integration: 'ceridian-dayforce', name: 'Ceridian Dayforce', icon: HRISCeridianIcon },
  { integration: 'altera-payroll', name: 'Altera Payroll', icon: HRISAlteraIcon },
  { integration: 'charlie', name: 'Charlie', icon: HRISCharlieIcon },
  { integration: 'lucca', name: 'Lucca', icon: HRISLuccaIcon },
  { integration: 'officient', name: 'Officient', icon: HRISOfficientIcon }
];
